export const SEARCH_FEEDSTOCK_REQUEST = 'SEARCH_FEEDSTOCK_REQUEST'
export const SEARCH_FEEDSTOCK_RESPONSE = 'SEARCH_FEEDSTOCK_RESPONSE'
export const SEARCH_FEEDSTOCK_ERROR = 'SEARCH_FEEDSTOCK_ERROR'

export const FETCH_FEEDSTOCK_PRICES_RESPONSE = 'FETCH_FEEDSTOCK_PRICES_RESPONSE'
export const FETCH_FEEDSTOCK_PRICES_ERROR = 'FETCH_FEEDSTOCK_PRICES_ERROR'
